var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "input-by-type",
      class: { "d-flex align-start": _vm.labelPosition === "left" },
      on: { click: _vm.handleRootClick }
    },
    [
      _vm.labelPosition === "left" &&
      (_vm.type === "checkbox" || !_vm.labelExternal)
        ? _c("div", {
            staticClass: "az-text-label",
            style: { width: _vm.labelWidth, flexShrink: 0 }
          })
        : _vm.labelExternal && _vm.type !== "checkbox"
        ? _c(
            "div",
            {
              staticClass: "az-text-label",
              style:
                _vm.labelPosition === "left"
                  ? {
                      width: _vm.labelWidth,
                      flexShrink: 0,
                      paddingTop: _vm.LABEL_LEFT_PADDING_TOP
                    }
                  : {}
            },
            [
              _vm._v(" " + _vm._s(_vm.labelExternalText) + " "),
              _vm.showRequiredAsterisk
                ? _c(
                    "span",
                    {
                      staticClass: "az-required-asterisk",
                      attrs: { "aria-hidden": "true" }
                    },
                    [_vm._v(" * ")]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "input-by-type__field",
          class: { "flex-grow-1": _vm.labelPosition === "left" }
        },
        [
          _vm.type === "file"
            ? _c(
                "div",
                { staticStyle: { position: "relative" } },
                [
                  _c(
                    "uploadFile",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            value: _vm.value,
                            "id-input": _vm.idInput || "upload-file-input",
                            "default-text": " ",
                            disabled: _vm.disabled,
                            label: _vm.label
                          },
                          on: { change: _vm.updateVal, input: _vm.importFile }
                        },
                        "uploadFile",
                        _vm.$attrs,
                        false
                      ),
                      _vm.$listeners
                    )
                  )
                ],
                1
              )
            : _vm.type === "date"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: _vm.masks.data,
                          expression: "masks.data"
                        }
                      ],
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u([
                        {
                          key: "prepend-inner",
                          fn: function() {
                            return [
                              _c("icon-svg", {
                                style: { color: _vm.colorIcon },
                                attrs: { name: "calendar", size: "18" }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "date_new_ux"
            ? _c(
                "v-menu",
                _vm._b(
                  {
                    ref: "menuDateUX",
                    staticClass: "remove-date-margin",
                    attrs: {
                      "close-on-content-click": false,
                      transition: "scroll-y-transition",
                      "max-width": 290,
                      "min-width": "auto",
                      "min-height": "auto",
                      left: !_vm.openMenuRight,
                      "offset-y": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: _vm.masks.data,
                                        expression: "masks.data"
                                      }
                                    ],
                                    staticClass: "new-ux align-icon-search",
                                    attrs: {
                                      value: _vm.value,
                                      label: _vm.label,
                                      placeholder: "DD/MM/AAAA",
                                      "hide-details": "",
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.disabled
                                    },
                                    on: { input: _vm.updateVal },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prepend-inner",
                                          fn: function() {
                                            return [
                                              _c("icon-svg", {
                                                staticStyle: {
                                                  color: "#8e8e8e"
                                                },
                                                attrs: {
                                                  name: "calendar",
                                                  size: "20"
                                                }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  "v-text-field",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.showMenu,
                      callback: function($$v) {
                        _vm.showMenu = $$v
                      },
                      expression: "showMenu"
                    }
                  },
                  "v-menu",
                  _vm.$attrs,
                  false
                ),
                [
                  _c("v-date-picker", {
                    ref: "pickerDateYearFirst",
                    attrs: {
                      type: "date",
                      "no-title": "",
                      scrollable: "",
                      locale: "pt-br",
                      min: _vm.formatDateMin,
                      max: _vm.formatDateMax
                    },
                    on: {
                      change: function($event) {
                        return _vm.changeDate($event, "menuDateUX")
                      }
                    },
                    model: {
                      value: _vm.dateDay,
                      callback: function($$v) {
                        _vm.dateDay = $$v
                      },
                      expression: "dateDay"
                    }
                  })
                ],
                1
              )
            : _vm.type === "date_month_new_ux"
            ? _c(
                "v-menu",
                _vm._b(
                  {
                    ref: "menuDateMonth",
                    attrs: {
                      "close-on-content-click": false,
                      transition: "scroll-y-transition",
                      "max-width": 290,
                      "min-width": "auto",
                      "min-height": "auto",
                      left: !_vm.openMenuRight,
                      "offset-y": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "new-ux align-icon-search",
                                    attrs: {
                                      value: _vm.formatMonthDate(_vm.value),
                                      label: _vm.label,
                                      placeholder: "MM/AAAA",
                                      readonly: "",
                                      "hide-details": "",
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.disabled
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prepend-inner",
                                          fn: function() {
                                            return [
                                              _c("icon-svg", {
                                                style: { color: _vm.colorIcon },
                                                attrs: {
                                                  name: "calendar",
                                                  size: "20"
                                                }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  "v-text-field",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.showMenu,
                      callback: function($$v) {
                        _vm.showMenu = $$v
                      },
                      expression: "showMenu"
                    }
                  },
                  "v-menu",
                  _vm.$attrs,
                  false
                ),
                [
                  _c("v-date-picker", {
                    attrs: {
                      type: "month",
                      "no-title": "",
                      scrollable: "",
                      locale: "pt-br",
                      min: _vm.formatDateMin,
                      max: _vm.formatDateMax
                    },
                    on: {
                      change: function($event) {
                        return _vm.changeDate($event, "menuDateMonth")
                      }
                    },
                    model: {
                      value: _vm.dateMonth,
                      callback: function($$v) {
                        _vm.dateMonth = $$v
                      },
                      expression: "dateMonth"
                    }
                  })
                ],
                1
              )
            : _vm.type === "date_quarter"
            ? _c(
                "v-menu",
                _vm._b(
                  {
                    ref: "menuDateQuarter",
                    attrs: {
                      "close-on-content-click": false,
                      transition: "scroll-y-transition",
                      "max-width": 290,
                      "min-width": "auto",
                      "min-height": "auto",
                      left: !_vm.openMenuRight,
                      "offset-y": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "new-ux align-icon-search",
                                    attrs: {
                                      value: _vm.formatQuarterDate(_vm.value),
                                      label: _vm.label,
                                      placeholder: "MM/AAAA",
                                      readonly: "",
                                      "hide-details": "",
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.disabled
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prepend-inner",
                                          fn: function() {
                                            return [
                                              _c("icon-svg", {
                                                staticStyle: {
                                                  color: "#8e8e8e"
                                                },
                                                attrs: {
                                                  name: "calendar",
                                                  size: "20"
                                                }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  "v-text-field",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.showMenu,
                      callback: function($$v) {
                        _vm.showMenu = $$v
                      },
                      expression: "showMenu"
                    }
                  },
                  "v-menu",
                  _vm.$attrs,
                  false
                ),
                [
                  _c("QuarterPicker", {
                    on: {
                      change: function($event) {
                        return _vm.changeDate($event, "menuDateQuarter")
                      }
                    },
                    model: {
                      value: _vm.dateMonth,
                      callback: function($$v) {
                        _vm.dateMonth = $$v
                      },
                      expression: "dateMonth"
                    }
                  })
                ],
                1
              )
            : _vm.type === "date_month"
            ? _c(
                "v-menu",
                _vm._b(
                  {
                    ref: "menuDateMonth",
                    attrs: {
                      "close-on-content-click": false,
                      transition: "scroll-y-transition",
                      "max-width": 290,
                      "min-width": "auto",
                      "min-height": "auto",
                      left: !_vm.openMenuRight,
                      "offset-y": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "no-border",
                                    style: { "max-width": "100px" },
                                    attrs: {
                                      value: _vm.formatMonthDate(_vm.value),
                                      label: _vm.label,
                                      placeholder: "MM/AAAA",
                                      readonly: "",
                                      "hide-details": "",
                                      dense: "",
                                      disabled: _vm.disabled
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prepend-inner",
                                          fn: function() {
                                            return [
                                              _c("icon-svg", {
                                                style: { color: _vm.colorIcon },
                                                attrs: {
                                                  name: "calendar",
                                                  size: "20"
                                                }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  "v-text-field",
                                  attrs,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.showMenu,
                      callback: function($$v) {
                        _vm.showMenu = $$v
                      },
                      expression: "showMenu"
                    }
                  },
                  "v-menu",
                  _vm.$attrs,
                  false
                ),
                [
                  _c("v-date-picker", {
                    attrs: {
                      type: "month",
                      "no-title": "",
                      scrollable: "",
                      locale: "pt-br",
                      min: _vm.formatDateMin,
                      max: _vm.formatDateMax
                    },
                    on: {
                      change: function($event) {
                        return _vm.changeDate($event, "menuDateMonth")
                      }
                    },
                    model: {
                      value: _vm.dateMonth,
                      callback: function($$v) {
                        _vm.dateMonth = $$v
                      },
                      expression: "dateMonth"
                    }
                  })
                ],
                1
              )
            : _vm.type === "date_with_widget"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: _vm.masks.data,
                          expression: "masks.data"
                        }
                      ],
                      staticClass: "input-date-with-widget",
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u([
                        {
                          key: "prepend-inner",
                          fn: function() {
                            return [
                              _c(
                                "v-menu",
                                {
                                  ref: "menu1",
                                  attrs: {
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    disabled: _vm.$attrs.readonly
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: { icon: "", small: "" }
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c("icon-svg", {
                                                staticStyle: {
                                                  color: "var(--primary)"
                                                },
                                                attrs: {
                                                  name: "calendar",
                                                  size: "20"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.showMenu,
                                    callback: function($$v) {
                                      _vm.showMenu = $$v
                                    },
                                    expression: "showMenu"
                                  }
                                },
                                [
                                  _c("v-date-picker", {
                                    attrs: {
                                      value: _vm.unformartDate(_vm.value),
                                      "no-title": "",
                                      locale: "pt-br"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.formatDate($event)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "date_ref"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: _vm.masks.dataRef,
                          expression: "masks.dataRef"
                        }
                      ],
                      attrs: {
                        placeholder: "MM/YYYY",
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "money"
            ? _c(
                "v-currency-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        prefix: _vm.MASK_BRL + " ",
                        autocomplete: "off",
                        type: _vm.hideData ? "password" : "text",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "append",
                            fn: function() {
                              return [_vm._t("append")]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    "v-currency-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "money_dolar"
            ? _c(
                "v-currency-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        prefix: _vm.MASK_USD + " ",
                        autocomplete: "off",
                        type: _vm.hideData ? "password" : "text",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "append",
                            fn: function() {
                              return [_vm._t("append")]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    "v-currency-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "percent"
            ? _c(
                "v-currency-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        suffix: " %",
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "append",
                            fn: function() {
                              return [_vm._t("append")]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    "v-currency-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : ["decimal", "float"].includes(_vm.type)
            ? _c(
                "v-currency-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-currency-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : "decimal_reverse" === _vm.type
            ? _c(
                "v-currency-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        "allow-negative": false,
                        "auto-decimal-mode": false,
                        "decimal-length": { min: 0, max: 15 },
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-currency-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : ["number", "integer"].includes(_vm.type)
            ? _c(
                "v-currency-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        "decimal-length": 0,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "append",
                            fn: function() {
                              return [_vm._t("append")]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    "v-currency-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "cnpj"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: _vm.masks.cnpj,
                          expression: "masks.cnpj"
                        }
                      ],
                      attrs: {
                        placeholder: "00.000.000/0000-00",
                        value: _vm.value,
                        label: _vm.label,
                        type: _vm.hideData ? "password" : "text",
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "cpf"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: _vm.masks.cpf,
                          expression: "masks.cpf"
                        }
                      ],
                      attrs: {
                        placeholder: "000.000.000-00",
                        value: _vm.value,
                        label: _vm.label,
                        type: _vm.hideData ? "password" : "text",
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "cpf_cnpj"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: [_vm.masks.cpf, _vm.masks.cnpj],
                          expression: "[masks.cpf, masks.cnpj]"
                        }
                      ],
                      attrs: {
                        placeholder: "000.000.000-00",
                        value: _vm.value,
                        label: _vm.label,
                        type: _vm.hideData ? "password" : "text",
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "cep"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: _vm.masks.cep,
                          expression: "masks.cep"
                        }
                      ],
                      attrs: {
                        placeholder: "00000-000",
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "telefone"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: [_vm.masks.phoneShort, _vm.masks.phoneLong],
                          expression: "[masks.phoneShort, masks.phoneLong]"
                        }
                      ],
                      attrs: {
                        placeholder: "(00) 0000-0000",
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "phoneWithCountryCodeBrazil"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: [
                            _vm.masks.phoneWithCountryCodeBrazil,
                            _vm.masks.phoneWithCountryCodeBrazilExtended
                          ],
                          expression:
                            "[\n        masks.phoneWithCountryCodeBrazil,\n        masks.phoneWithCountryCodeBrazilExtended,\n      ]"
                        }
                      ],
                      attrs: {
                        placeholder: "+55 (00) 0000-0000",
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : ["e-mail", "email"].includes(_vm.type)
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : "search" === _vm.type
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "no-border align-icon-search icon-primary",
                      staticStyle: { overflow: "hidden" },
                      style: { maxWidth: _vm.maxWidth },
                      attrs: {
                        placeholder: _vm.$attrs.placeholder || "Pesquisar",
                        filled: "",
                        "hide-details": "",
                        dense: "",
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u([
                        {
                          key: "prepend-inner",
                          fn: function() {
                            return [
                              _c("icon-svg", {
                                attrs: {
                                  name: "mdi-magnify",
                                  color: "var(--neutral-400)",
                                  size: "20"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : "textarea" === _vm.type
            ? _c(
                "v-textarea",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        counter: _vm.counter,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-textarea",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : "textarea-new-ux" === _vm.type
            ? _c(
                "v-textarea",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "textarea-new-ux",
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-textarea",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "codigo_boleto"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: [_vm.masks.codigoBoleto, _vm.masks.imposto],
                          expression: "[masks.codigoBoleto, masks.imposto]"
                        }
                      ],
                      attrs: {
                        placeholder:
                          "00000.00000 00000.000000 00000.000000 0 00000000000000",
                        value: _vm.value,
                        label: _vm.label,
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "select"
            ? _c(
                "v-autocomplete",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "new-ux",
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        items: _vm.options,
                        disabled: _vm.disabled,
                        "menu-props": { offsetY: true },
                        outlined: ""
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-autocomplete",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "select-search"
            ? _c(
                "SelectSearch",
                _vm._g(
                  _vm._b(
                    {
                      ref: "selectSearch",
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        items: _vm.options,
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u(
                        [
                          _vm.$scopedSlots.footer
                            ? {
                                key: "footer",
                                fn: function() {
                                  return [_vm._t("footer")]
                                },
                                proxy: true
                              }
                            : null
                        ],
                        null,
                        true
                      )
                    },
                    "SelectSearch",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "select-search-props"
            ? _c(
                "SelectSearch",
                _vm._g(
                  _vm._b(
                    {
                      ref: "selectSearch",
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        items: _vm.options,
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item",
                            fn: function(slotProps) {
                              return [_vm._t("item", null, null, slotProps)]
                            }
                          },
                          {
                            key: "selection",
                            fn: function(slotProps) {
                              return [
                                _vm._t("selection", null, null, slotProps)
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    "SelectSearch",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "year"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: _vm.masks.year,
                          expression: "masks.year"
                        }
                      ],
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        type: "text",
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "checkbox"
            ? _c(
                "v-checkbox",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "new-ux input-by-type__checkbox ma-0 pa-0",
                      attrs: {
                        label: _vm.label || _vm.labelExternal,
                        "input-value": Boolean(_vm.value),
                        disabled: _vm.disabled
                      },
                      on: { change: _vm.updateVal }
                    },
                    "v-checkbox",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "time"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        type: "time",
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "clock_time"
            ? _c(
                "ClockTimePicker",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "ClockTimePicker",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "liquidity"
            ? _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: _vm.masks.liquidity,
                          expression: "masks.liquidity"
                        }
                      ],
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        placeholder: "D+0",
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "markdown-editor"
            ? _c(
                "MarkdownField",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "footer",
                            fn: function() {
                              return [_vm._t("footer")]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    "MarkdownField",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _vm.type === "autocomplete"
            ? _c(
                "v-autocomplete",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        items: _vm.options,
                        disabled: _vm.disabled,
                        autocomplete: "off",
                        outlined: "",
                        "menu-props": Object.assign(
                          {},
                          { offsetY: true },
                          _vm.$attrs["menu-props"]
                        )
                      },
                      on: { input: _vm.updateVal },
                      scopedSlots: _vm._u(
                        [
                          _vm.$scopedSlots.item
                            ? {
                                key: "item",
                                fn: function(slotProps) {
                                  return [_vm._t("item", null, null, slotProps)]
                                }
                              }
                            : null,
                          _vm.$scopedSlots.selection
                            ? {
                                key: "selection",
                                fn: function(slotProps) {
                                  return [
                                    _vm._t("selection", null, null, slotProps)
                                  ]
                                }
                              }
                            : null
                        ],
                        null,
                        true
                      )
                    },
                    "v-autocomplete",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            : _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        value: _vm.value,
                        label: _vm.label,
                        type: _vm.hideData ? "password" : "text",
                        autocomplete: "off",
                        disabled: _vm.disabled
                      },
                      on: { input: _vm.updateVal }
                    },
                    "v-text-field",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }